import { User } from '@f-fertighaus/applications/Next/types/User'
import { Nullable } from '@f-fertighaus/applications/Next/types/utility'

import { useLocalStorage } from '@f-fertighaus/applications/Next/hooks/useLocalStorage'

export function useUserPostcode(): Nullable<string> {
  const user = useLocalStorage<User>('user')

  return user ? user?.project?.delivery_region?.postcode : null
}
